<template>
  <!-- <v-lazy v-if="asset.url" transition="fade-transition">
    <img :src="asset.url" :alt="alt" />
  </v-lazy> -->
  <div>
    <v-img
      :aspect-ratio="asset.aspectRatio"
      class="grey lighten-4 my-4"
      :eager="true"
      :src="asset.url"
    />
    <!-- <noscript><img :src="asset.url" /></noscript> -->
  </div>
</template>

<script>
export default {
  props: {
    asset: {
      type: Object,
      required: true
    },
    alt: {
      type: String,
      default: 'Missing alternative text'
    },
    width: {
      default: null,
      type: Number
    },
    height: {
      default: null,
      type: Number
    },
    auto: {
      default: 'format',
      type: String
    },
    fit: {
      default: 'max',
      type: String
    }
  },
  computed: {
    // altFromImage: function() {
    //   return this.image.alt
    // },
    // imageUrl: function() {
    //   return builder
    //     .image(this.image)
    //     .size(this.width, this.height)
    //     .auto(this.auto)
    //     .fit(this.fit)
    // }
  }
}
</script>
